export default __webpack_public_path__ + "static/media/Calender.f02dc926.svg";